import { BSL_LEVELS } from '../constants/sample.constants';
import { escapeHtml } from './escapeHtml';

/** フォーム選択肢順（BSL-1→4、ABSL-1→4）。未知は末尾 */
export function compareBslLevels(
  a: string | null | undefined,
  b: string | null | undefined
): number {
  const ia = BSL_LEVELS.indexOf((a || '') as (typeof BSL_LEVELS)[number]);
  const ib = BSL_LEVELS.indexOf((b || '') as (typeof BSL_LEVELS)[number]);
  const ka = ia === -1 ? 1000 : ia;
  const kb = ib === -1 ? 1000 : ib;
  if (ka !== kb) return ka - kb;
  return String(a || '').localeCompare(String(b || ''));
}

/** ダッシュボード BSL 棒の並び（件数順ではなくレベル順） */
export function sortBslCountBars<T extends { level: string }>(bars: T[]): T[] {
  return [...bars].sort((x, y) => compareBslLevels(x.level, y.level));
}

/** 一覧セル用: BSL/ABSL の危険度トーン（色は CSS `.sample-bsl-tone--*`） */
export function bslLevelToneClass(bsl: string | null | undefined): string {
  const s = (bsl || '').toUpperCase();
  if (s.includes('BSL-4') || s.includes('ABSL-4')) return 'sample-bsl-tone sample-bsl-tone--4';
  if (s.includes('BSL-3') || s.includes('ABSL-3')) return 'sample-bsl-tone sample-bsl-tone--3';
  if (s.includes('BSL-2') || s.includes('ABSL-2')) return 'sample-bsl-tone sample-bsl-tone--2';
  if (s.includes('BSL-1') || s.includes('ABSL-1')) return 'sample-bsl-tone sample-bsl-tone--1';
  return 'sample-bsl-tone';
}

/** DataTables / 静的表の BSL セル HTML */
export function formatBslLevelCellHtml(bsl: unknown): string {
  const raw = bsl == null || bsl === '' ? '' : String(bsl);
  if (!raw) return '-';
  const escaped = escapeHtml(raw);
  return `<span class="${bslLevelToneClass(raw)}" title="${escaped}">${escaped}</span>`;
}
